import { Button } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import ProfileIcon from '@mui/icons-material/AccountBox';
import { logout, removeKey, removeToken } from 'src/services/auth.service';
import { useNavigate } from 'react-router-dom';


const React = require('react');

class LogoutAndProfileButton extends React.Component {

	constructor(props) {
		super(props);
	}

	handleLogout = async () => {
	
		try {
			await logout();
		} catch (error) { }

		removeToken();
		removeKey('username');
		removeKey('role');
		this.props.navigate('/login');
	}

	render() {
		return (
			<>
				<Button
					variant="text"
					size="small"
					fullWidth
					onClick={() => this.props.navigate('/profile')}
					startIcon={<ProfileIcon size="small" sx={{ mr: 1, fontSize: 10 }} />}
				>
					Profile
				</Button>

				<Button
					variant="text"
					size="small"
					fullWidth
					onClick={this.handleLogout}
					startIcon={<LogoutIcon size="small" sx={{ mr: 1, fontSize: 10 }} />}
				>
					Logout
				</Button>
			</>
		);
	}
}

export default function (props) {
  const navigate = useNavigate();

  return <LogoutAndProfileButton {...props} navigate={navigate} />;
}
